import React from 'react';
import { Text } from '@fluentui/react';
import PropTypes from 'prop-types';

const textStyles = {
  root: {
    marginBottom: 12,
  },
};

export const SectionDescription = (props) => {
  const { text } = props;

  return (
    <Text block styles={textStyles}>
      {text}
    </Text>
  );
};

SectionDescription.propTypes = {
  text: PropTypes.string.isRequired,
};
